import { Button } from "@mantine/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { BookingOption } from "@/constants";
import { trackEvent } from "@/tracking";

type Props = {
  bookingOption: BookingOption;
};

export function BookingButton({ bookingOption }: Props) {
  return (
    <Button
      variant="light"
      color="sea"
      size="md"
      radius="xl"
      rightSection={<FontAwesomeIcon icon={bookingOption.icon} />}
      onClick={() => {
        trackEvent("Booking Provider Click", {
          provider: bookingOption.name,
          location: "booking-page",
        });
        window.open(bookingOption.url, "_blank", "noopener,noreferrer");
      }}
    >
      {bookingOption.name}
    </Button>
  );
}

export default BookingButton;
